import React from 'react';
import CheckList from '../../../../Elements/CheckList';
import CheckListToneEnum from '../../../../Enums/CheckListToneEnum';
import { formatCount } from '../../../../Helpers/invoiceAutomationRunHelper';

// Why a run would leave jobs out, under a small capitals title: a row for each reason, with the number of jobs it
// holds back on the right. reasons are { reason, jobCount }, as the run preview sends them; tone is a
// CheckListToneEnum value. Nothing is shown without reasons.
export default function InvoiceAutomationReasonCounts({ title = '', reasons = [], tone = CheckListToneEnum.Info }) {
  if (reasons.length === 0) {
    return null;
  }

  const items = reasons.map((reasonCount) => ({
    tone,
    text: (
      <span className='iauto-reason'>
        <span>{reasonCount.reason}</span>
        <b className='iauto-reason-count'>{formatCount(reasonCount.jobCount, 'job', 'jobs')}</b>
      </span>
    ),
  }));
  return (
    <section className='iauto-run-section'>
      <h4>{title}</h4>
      <CheckList items={items} />
    </section>
  );
}
